export default __webpack_public_path__ + "images/66350656d346eade1110e45bcb43e823.svg";